import gsap from 'gsap';

const updateCollapsibleSections = (sectionMap, newCollapsedSections) => {
  // update the heights of the children of sections
  // update the icons of the sections
  let divsToCollapse,
    divsToExpand,
    allSectionIds,
    collapsedSectionKeys,
    headersToCollapse,
    headersToExpand;
  divsToCollapse = [];
  divsToExpand = [];
  allSectionIds = Object.keys(sectionMap);
  allSectionIds.forEach(id => {
    if (id && sectionMap[id]) {
      if (newCollapsedSections[id] === true) {
        divsToCollapse = [...divsToCollapse, ...sectionMap[id]];
      } else if (newCollapsedSections[id] === false) {
        divsToExpand = [...divsToExpand, ...sectionMap[id]];
      }
    }
  });
  collapsedSectionKeys = Object.keys(newCollapsedSections);
  headersToCollapse = [];
  headersToExpand = [];
  collapsedSectionKeys.forEach(one => {
    if (newCollapsedSections[one] === true) {
      headersToCollapse.push(one);
    } else if (newCollapsedSections[one] === false) {
      headersToExpand.push(one);
    }
  });
  headersToCollapse.forEach(id => {
    gsap.to(`[field-id=${id}] .section-expansion-icon`, {
      css: { rotation: -90 }
    });
    gsap.to(`[field-id=${id}] [role=field-description]`, {
      height: 0,
      padding: 0
    });
  });
  headersToExpand.forEach(id => {
    gsap.set(`[field-id=${id}]`, { display: 'block' });
    gsap.to(`[field-id=${id}] .section-expansion-icon`, {
      css: { rotation: 0 }
    });
    gsap.to(`[field-id=${id}] [role=field-description]`, {
      height: 'auto',
      padding: 'auto',
      autoAlpha: 1
    });
  });
  divsToCollapse.forEach(id => {
    gsap.to(`[field-id=${id}]`, {
      height: 0
    });
  });
  divsToExpand.forEach(id => {
    const matchingElement = document.querySelector(`[field-id=${id}]`);
    if (matchingElement && matchingElement.classList && matchingElement.classList.contains('hiddenByLogic')) {
      return;
    }
    gsap.set(`[field-id=${id}]`, { display: 'block' });
    gsap.to(`[field-id=${id}]`, {
      height: 'auto',
      autoAlpha: 1
    });
  });
};

export default updateCollapsibleSections;
